import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AutomaticPointsSettingsPage } from './automatic-points-settings.page';

const routes: Routes = [
  {
    path: '',
    component: AutomaticPointsSettingsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AutomaticPointsSettingsPageRoutingModule {}
